import Heading from 'components/Heading'
import React from 'react'

import addContainerNotes from './Images/container-notes-add-container-notes.png'
import addContainerNotesSearch from './Images/container-notes-add-container-notes-search.png'
import containerNotesAddedInHome from './Images/container-notes-added-in-home.png'
import containerNotesPage from './Images/container-notes-page.png'
import containerNotesWebAndMobileView from './Images/container-notes-web-and-mobile-view.png'

const ContainerNotes = () => (
  <div>
    <Heading isDark level={2}>
      Container Notes
    </Heading>

    <p>
      The Container Notes feature allows crews to add, view, update, and
      complete notes for individual containers using the CargoMate mobile
      device. It helps record operational information, damages, exceptions,
      special handling requirements, and other container-related remarks during
      cargo operations.
    </p>

    <Heading isDark level={3}>
      Accessing Container Notes
    </Heading>
    <p>
      Container Notes can be accessed in three different ways. All methods
      provide the same functionality and allow users to create, edit, view, and
      complete notes for a container.
    </p>

    <Heading isDark level={4}>
      Option 1 – Progress Screen → Container Notes
    </Heading>
    <p>
      Open the Progress screen. Navigate to Container Notes and click the Add
      icon. Search by Container Number or Cell. Enter the notes and update.
    </p>

    <div style={{ display: 'flex', gap: '14px' }}>
      <img src={containerNotesAddedInHome} />
      <img src={containerNotesPage} />
    </div>

    <Heading isDark level={4}>
      Option 2 – Cargo Plan → Search
    </Heading>
    <p>
      Open the Cargo Plan page, click the Search icon in the top-left corner,
      and enter the Container Number or Cell Number to access and manage notes.
    </p>
    <img src={addContainerNotesSearch} />

    <Heading isDark level={4}>
      Option 3 – Bay Plan → Long Press Container → Notes
    </Heading>
    <p>
      Open the Bay Plan page, locate the container, perform a long press, and
      select Notes from the menu to add, view, or manage notes.
    </p>
    <img src={addContainerNotes} />

    <Heading isDark level={3}>
      3. Container Notes Summary
    </Heading>
    <img src={containerNotesWebAndMobileView} />
  </div>
)

export default ContainerNotes
